import {ActionTree} from 'vuex'
import {AxiosResponse, AxiosError} from "axios";
import moment from 'moment';
// @ts-ignore
import Api from "@/api.js";

export const actions: ActionTree<any, any> = {

    checkPasswordCreate: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            if (!data.token) {
                delete (data.token);
            }

            Api.post('/app-api/email', data)

                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    login: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            if (!data.token) {
                delete (data.token);
            }

            data.email = data.email.toLowerCase();

            Api.post('/app-api/login', data)

                .then((response: AxiosResponse) => {

                    commit('setOAuthData', response.data.oauth);

                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    getAccountDetails: ({state, getters, commit, dispatch}, force = false) => {

        return new Promise((resolve, reject) => {

            if (!force && state.accountExpires && moment().isBefore(state.accountExpires)) {
                resolve(state.account);
                return;
            }

            Api.get('/api/community/account', {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })
                .then((response: AxiosResponse) => {

                    commit('setAccountDetails', response.data.data);

                    resolve(response);

                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    getAvailableProjects: ({state, getters, commit, dispatch}, force = false) => {

        return new Promise((resolve, reject) => {

            if (!force && state.availableProjectsExpires && moment().isBefore(state.availableProjectsExpires)) {
                resolve(state.availableProjects);
                return;
            }

            Api.get('/api/community/available-projects', {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })

                .then((response: AxiosResponse) => {

                    if (response.status === 200) {
                        commit('setAvailableProjects', response.data.data);
                    } else {
                        commit('setAvailableProjects', []);
                    }

                    resolve(response);

                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    getQuestions: ({state, getters, commit, dispatch}, force = false) => {

        return new Promise((resolve, reject) => {

            if (!force && state.availableQuestionsExpires && moment().isBefore(state.availableQuestionsExpires)) {
                resolve(true);
                return;
            }

            Api.get('/api/community/dynamic-profiling', {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })
                .then((response: AxiosResponse) => {
                    commit('setAvailableQuestions', response.data);
                    resolve(true);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },


    getRewards: ({state, getters, commit, dispatch}, force = false) => {

        return new Promise((resolve, reject) => {

            if (!force && state.rewardsExpires && moment().isBefore(state.rewardsExpires)) {
                resolve(state.rewards);
                return;
            }

            Api.get('/api/community/rewards', {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })

                .then((response: AxiosResponse) => {

                    commit('setRewards', response.data.data);

                    resolve(response);

                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    getCollectedData: ({state, getters, commit, dispatch}) => {

        return new Promise((resolve, reject) => {

            Api.get('/api/community/account/data', {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })

                .then((response: AxiosResponse) => {

                    commit('setCollectedData', response.data.data);

                    resolve(response);

                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    redeemReward: ({state, getters, commit, dispatch}, reward) => {

        return new Promise((resolve, reject) => {

            Api.post('/api/community/redemption', {id: reward.id}, {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })

                .then((response: AxiosResponse) => {

                    commit('deductRewardPoints', reward);
                    commit('clearRedemptionHistoryCache');

                    resolve(response);

                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    getRedemptionHistory: ({state, getters, commit, dispatch}, force = false) => {

        return new Promise((resolve, reject) => {

            if (!force && state.redemptionHistoryExpires && moment().isBefore(state.redemptionHistoryExpires)) {
                resolve(state.redemptions);
                return;
            }

            Api.get('/api/community/redemptions', {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })

                .then((response: AxiosResponse) => {
                    commit('setRedemptionHistory', response.data.data);
                    resolve(response);

                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    closeUserAccount: ({state, getters, commit, dispatch}) => {

        return new Promise((resolve, reject) => {

            Api.delete('/api/community/account', {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })

                .then((response: AxiosResponse) => {

                    resolve(response);

                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    resetPassword: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            Api.post('/api/community/reset-password', data)

                .then((response: AxiosResponse) => {
                    resolve(response);

                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    getActivityHistory: ({state, getters, commit, dispatch}, force = false) => {

        return new Promise((resolve, reject) => {

            if (!force && state.activityHistoryExpires && moment().isBefore(state.activityHistoryExpires)) {
                resolve(state.activity);
                return;
            }

            Api.get('/api/community/activity-history', {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })
                .then((response: AxiosResponse) => {
                    commit('setActivityHistory', response.data.data);
                    resolve(response);

                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    referFriends: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            Api.post('/api/community/refer-friends', data, {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })
                .then((response: AxiosResponse) => {
                    commit('setAccountDetails', response.data.data.account);
                    resolve(response);

                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    getReferFriendLink: ({state, getters, commit, dispatch}) => {

        return new Promise((resolve, reject) => {

            Api.get('/api/community/refer-friend-link', {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })
                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    loadNotificationPreferences: ({state, getters, commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            Api.get('/api/community/notifications', {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })
                .then((response: AxiosResponse) => resolve(response))
                .catch((error: AxiosError) => reject(error));
        });
    },

    saveNotificationPreferences: ({state, getters, commit, dispatch}, data) => {
        return new Promise((resolve, reject) => {
            Api.post('/api/community/notifications', {data: data}, {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })
                .then((response: AxiosResponse) => resolve(response))
                .catch((error: AxiosError) => reject(error));
        });
    },

    saveAnswer: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            Api.post('/api/community/dynamic-profiling', data, {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })
                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    updateNotificationToken: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            Api.post('/api/community/notification-token', data, {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                }
            })
                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    deleteNotificationToken: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            Api.delete('/api/community/notification-token', {
                headers: {
                    Authorization: 'Bearer ' + state.oauth.access_token
                },
                data: data
            })
                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },
}

